const WIZARD_PREFIX = 'mge:wizard:';
const JOINED_PREFIX = 'mge:joined:';

export type WizardCache = {
  step: 'team' | 'identity';
  teamId?: string;
  createTeamName?: string;
  displayName?: string;
  handicap?: number | null;
};

export type JoinedState = { participantId: string; teamId?: string };

function safeRead<T>(key: string): T | null {
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

function safeWrite(key: string, value: unknown): void {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* ignore quota / private mode */
  }
}

function safeRemove(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

export const joinCache = {
  setWizard(code: string, c: WizardCache): void {
    safeWrite(WIZARD_PREFIX + code, c);
  },
  getWizard(code: string): WizardCache | null {
    return safeRead<WizardCache>(WIZARD_PREFIX + code);
  },
  clearWizard(code: string): void {
    safeRemove(WIZARD_PREFIX + code);
  },
  setJoined(eventId: string, j: JoinedState): void {
    safeWrite(JOINED_PREFIX + eventId, j);
  },
  getJoined(eventId: string): JoinedState | null {
    return safeRead<JoinedState>(JOINED_PREFIX + eventId);
  },
  clearAll(): void {
    try {
      const toRemove: string[] = [];
      for (let i = 0; i < window.localStorage.length; i++) {
        const k = window.localStorage.key(i);
        if (k && (k.startsWith(WIZARD_PREFIX) || k.startsWith(JOINED_PREFIX))) {
          toRemove.push(k);
        }
      }
      toRemove.forEach((k) => window.localStorage.removeItem(k));
    } catch {
      /* ignore */
    }
  },
};
